import React, { useMemo } from 'react';

import { fetchEvent, fetchUserEvents } from '../../data/fetch';
import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';
import WaitWhileBusy from '../WaitWhileBusy';

const LoadEvent = ({ eventId, children }) => {
    const memoizedPromise = useMemo(() => fetchUserEvents().then(() => fetchEvent(eventId)), [eventId, fetchUserEvents()]);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.event.loaded} promises={[memoizedPromise]}>
            <WaitWhileBusy>{children}</WaitWhileBusy>
        </Loader>
    );
};

export default LoadEvent;
